import { render, staticRenderFns } from "./StateInfo.vue?vue&type=template&id=584bffdb"
import script from "./StateInfo.vue?vue&type=script&lang=js"
export * from "./StateInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports